<div class="flex flex-col items-center justify-center p-16 text-center">
  <fa-icon
    [icon]="faTriangleExclamation"
    class="text-5xl text-red-500 mb-4"
  ></fa-icon>

  <h2 class="text-xl font-semibold text-red-700 mb-2">Prüfung fehlgeschlagen</h2>

  <p class="text-gray-600 max-w-lg mb-6">{{ error }}</p>

  @if (details) {
<div class="w-full max-w-lg mb-6">
    <button
      (click)="toggleDetails()"
      class="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1 mx-auto"
      type="button"
    >
      <span>Details anzeigen</span>
      <fa-icon [icon]="detailsExpanded ? faChevronUp : faChevronDown" class="text-xs"></fa-icon>
    </button>

    @if (detailsExpanded) {
<div
     
      class="mt-3 p-4 bg-red-50 border border-red-200 rounded-lg text-left text-sm text-red-800 whitespace-pre-wrap break-words"
    >
      {{ details }}
    </div>
}
  </div>
}

  <div class="flex gap-3">
    <bic-button (click)="close.emit()" [style]="'secondary'">Schließen</bic-button>
    @if (canViewLogs) {
<bic-button (click)="viewLogs.emit()" [style]="'secondary'">
      <fa-icon [icon]="faFileLines" class="mr-2"></fa-icon>
      Logs anzeigen
    </bic-button>
}
    <bic-button (click)="retry.emit()" [style]="'primary'">Erneut versuchen</bic-button>
  </div>
</div>
